import choozy from 'choozy'
import { component } from 'picoapp'
import { on } from 'martha'
import dcx from 'dcx'

export default component((node) => {
  const { editButton, editForm, deleteButton, cancelButton } = choozy(node)
  const editFormCx = dcx(editForm)
  let isEditFormActive = false

  on(editButton, 'click', () => {
    isEditFormActive = !isEditFormActive
    render()
  })

  on(deleteButton, 'click', () => {
    if (!confirm('Are you sure you wish to delete this address?')) return

    const form = document.createElement('form')
    const input = document.createElement('input')

    form.setAttribute('method', 'post')
    form.setAttribute('action', '/account/addresses/' + node.dataset.id)

    input.setAttribute('type', 'hidden')
    input.setAttribute('name', '_method')
    input.setAttribute('value', 'delete')

    form.appendChild(input)

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  })

  on(cancelButton, 'click', () => {
    isEditFormActive = false
    render()
  })

  function render() {
    editFormCx({ hidden: !isEditFormActive })
  }
})
